import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import styled from 'styled-components';
import { InfoButtonComponent } from '../Info/InfoButton';
import { cardKeys, cardMixin } from '../mixins/card';
import { fullHeightKeys, fullHeightMixin, fullWidthKeys, fullWidthMixin, heightKeys, heightMixin, widthKeys, widthMixin } from '../mixins/layout';
import { buttonCursorMixin } from '../mixins/button';
import { omitProps } from '../helpers/elements';
import { useDeviceType } from '../hooks';
import { buttonResetStyle } from '../tokens/button';
import { appearanceNoneStyle } from '../tokens/appearance';
export var CardComponent = styled(omitProps(function (_ref, forwardedRef) {
  var as = _ref.as,
      props = _objectWithoutPropertiesLoose(_ref, ["as"]);

  return /*#__PURE__*/React.createElement(InfoButtonComponent, _extends({
    forwardedAs: as,
    ref: forwardedRef
  }, props));
}, [].concat(cardKeys, fullWidthKeys, fullHeightKeys, widthKeys, heightKeys)))(_templateObject(), buttonResetStyle, appearanceNoneStyle, cardMixin, fullWidthMixin, fullHeightMixin, widthMixin, heightMixin, buttonCursorMixin);
var Card = /*#__PURE__*/React.forwardRef(function (_ref2, forwardedRef) {
  var as = _ref2.as,
      forwardedAs = _ref2.forwardedAs,
      _ref2$fullWidth = _ref2.fullWidth,
      fullWidth = _ref2$fullWidth === void 0 ? true : _ref2$fullWidth,
      props = _objectWithoutPropertiesLoose(_ref2, ["as", "forwardedAs", "fullWidth"]);

  var _useDeviceType = useDeviceType(),
      hasTouchScreen = _useDeviceType.hasTouchScreen;

  return /*#__PURE__*/React.createElement(CardComponent, _extends({
    forwardedAs: forwardedAs != null ? forwardedAs : as,
    ref: forwardedRef,
    fullWidth: fullWidth,
    hasTouch: hasTouchScreen
  }, props));
});
export default Card;